import { apiClient } from './api/apiClient';
import {
  ShiftRequest,
  PagedResponse,
  ApiResponse,
  RequestType,
  RequestStatus,
} from '../types';

interface CreateShiftRequestDto {
  type: RequestType;
  shiftId?: number;
  requestedDateStart: string;
  requestedDateEnd?: string;
  reason?: string;
  swapWithEmployeeId?: number;
}

interface ReviewShiftRequestDto {
  approved: boolean;
  rejectionReason?: string;
}

interface ShiftRequestFilter {
  employeeId?: number;
  approvedBy?: number;
  type?: RequestType;
  status?: RequestStatus;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
}

class ShiftRequestService {
  /**
   * Ottieni lista richieste turno
   */
  async getShiftRequests(filter?: ShiftRequestFilter): Promise<PagedResponse<ShiftRequest>> {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.employeeId) params.append('employeeId', filter.employeeId.toString());
      if (filter.approvedBy) params.append('approvedBy', filter.approvedBy.toString());
      if (filter.type !== undefined) params.append('type', filter.type.toString());
      if (filter.status !== undefined) params.append('status', filter.status.toString());
      if (filter.startDate) params.append('startDate', filter.startDate);
      if (filter.endDate) params.append('endDate', filter.endDate);
      if (filter.page) params.append('page', filter.page.toString());
      if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
    }

    return await apiClient.get<PagedResponse<ShiftRequest>>(
      `/shiftrequests?${params.toString()}`
    );
  }

  /**
   * Ottieni dettagli richiesta per ID
   */
  async getShiftRequestById(id: number): Promise<ShiftRequest> {
    const response = await apiClient.get<ApiResponse<ShiftRequest>>(
      `/shiftrequests/${id}`
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Richiesta non trovata');
  }

  /**
   * Crea nuova richiesta turno
   */
  async createShiftRequest(data: CreateShiftRequestDto): Promise<ShiftRequest> {
    const response = await apiClient.post<ApiResponse<ShiftRequest>>(
      '/shiftrequests',
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nella creazione della richiesta');
  }

  /**
   * Approva o rifiuta richiesta
   */
  async reviewShiftRequest(
    id: number,
    data: ReviewShiftRequestDto
  ): Promise<ShiftRequest> {
    const response = await apiClient.post<ApiResponse<ShiftRequest>>(
      `/shiftrequests/${id}/review`,
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nella revisione della richiesta');
  }

  /**
   * Cancella richiesta
   */
  async cancelShiftRequest(id: number): Promise<void> {
    await apiClient.delete(`/shiftrequests/${id}`);
  }
}

// Export singleton instance
export const shiftRequestService = new ShiftRequestService();
